import Styles from './Onboarding.module.scss';
import WizardNav from '@components/WizardNav';
import PropTypes from 'prop-types';

const Row = ({ children, ...props }) => {
  return (
    <div className={Styles.row} {...props}>
      {children}
    </div>
  );
};

const Footer = ({ children, hasAgreement = false, ...props }) => {
  return (
    <div className={Styles.footer} {...props}>
      {children}
      {hasAgreement && (
        <div className={Styles.smallNote}>
          {`By submitting this form, you are agreeing to Hire Digital's `}
          <a href={`/terms`} className={Styles.link}>{`Terms of Service`}</a>
          {`, `}
          <a href={`/privacy`} className={Styles.link}>{`Privacy Policy`}</a>
          {`, and `}
          <a href={`/privacy`} className={Styles.link}>{`Cookie Policy`}</a>
          {`.`}
        </div>
      )}
    </div>
  );
};

const Headline = ({ content, children, ...props }) => {
  return (
    <div className={Styles.headline} {...props}>
      {content || children}
    </div>
  );
};

const SubHeadline = ({ content, children, ...props }) => {
  return (
    <div className={Styles.subheadline} {...props}>
      {content || children}
    </div>
  );
};

const Header = ({ children, ...props }) => {
  return (
    <div className={Styles.header} {...props}>
      {children}
    </div>
  );
};

const RightArea = ({ headline, subheadline, children, hasNav, activeNavIndex, ...props }) => {
  const isEmpty = (v) => v === undefined || v === null;
  return (
    <div className={Styles.rightArea} {...props}>
      <div className={Styles.rightChild}>
        {(hasNav || !isEmpty(activeNavIndex)) && (
          <WizardNav
            selected={activeNavIndex}
            items={[
              { text: 'Register', onClick: () => false },
              { text: 'Brief', onClick: () => false },
              { text: 'Schedule Call', onClick: () => false },
            ]}
          />
        )}

        {(headline || subheadline) && (
          <Header>
            {headline && <Headline content={headline} />}
            {subheadline && <SubHeadline content={subheadline} />}
          </Header>
        )}

        {children}
      </div>
    </div>
  );
};

RightArea.propTypes = {
  headline: PropTypes.string,
  subheadline: PropTypes.string,
  children: PropTypes.node,
  activeNavIndex: PropTypes.number,
  hasNav: PropTypes.bool,
};

RightArea.Row = Row;
RightArea.Header = Header;
RightArea.Footer = Footer;
RightArea.Headline = Headline;
RightArea.SubHeadline = SubHeadline;

export default RightArea;
